export const reBuildQuestion = <QuestionType>(
  update: (question: QuestionType) => QuestionType,
  questionId: string,
  tableId?: string,
) => {
  if (tableId) {
    return (prevQuestions: any[]) => {
      return prevQuestions.map((question) => {
        if (question.id === tableId) {
          const updatedQuestion = { ...question };
          updatedQuestion.questions = updatedQuestion.questions.map(
            (subQuestion: QuestionType & { id: string }) => {
              if (subQuestion.id === questionId) {
                const updatedSubQuestion = update(subQuestion);
                return { ...updatedSubQuestion };
              }
              return subQuestion;
            },
          );
          return updatedQuestion;
        }
        return question;
      });
    };
  } else {
    return (prevQuestions: any[]) => {
      return prevQuestions.map((question) => {
        if (question.id === questionId) {
          const updatedQuestion = update(question);
          return updatedQuestion;
        }
        return question;
      });
    };
  }
};
